module.exports = __webpack_public_path__ + "static/media/vrms-sort-table-column.3c9f63ea.svg";